var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-select',{attrs:{"options":_vm.egressProfileCycles,"size":"sm","value-field":"id","text-field":"name","disabled":_vm.disabled || !isNaN(_vm.cycle_id) || !_vm.can_edit_cycle},on:{"change":_vm.slotCycleUpdated},model:{value:(_vm.selected_cycle),callback:function ($$v) {_vm.selected_cycle=$$v},expression:"selected_cycle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }